import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid gap-3 grid-cols-1" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "flex items-center justify-center w-14 h-14 rounded-[11.2px] bg-primary50 shrink-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-bold leading-6 tracking-[0.08px]" }, "Criar escala", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal leading-[18px] tracking-[0.07px] text-[#F0F0F4]" }, " Configure uma nova escala de trabalho ", -1)
const _hoisted_6 = {
  class: "w-6 h-6 shrink-0",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GerenciarEscalasIcon = _resolveComponent("GerenciarEscalasIcon")!
  const _component_ListSchedules = _resolveComponent("ListSchedules")!
  const _component_CreateHospitalModal = _resolveComponent("CreateHospitalModal")!
  const _component_RemoveScheduleModal = _resolveComponent("RemoveScheduleModal")!
  const _component_UpdateScheduleModal = _resolveComponent("UpdateScheduleModal")!
  const _component_PositionsModal = _resolveComponent("PositionsModal")!
  const _component_PoliciesModal = _resolveComponent("PoliciesModal")!
  const _component_RemovePositionModal = _resolveComponent("RemovePositionModal")!
  const _component_UpdatePositionModal = _resolveComponent("UpdatePositionModal")!
  const _component_EditScheduleModal = _resolveComponent("EditScheduleModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.canCreateSchedule)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            "data-testid": "manage-scale-criar-escala-button",
            class: "w-full hover:shadow-lg bg-primary30 text-white text-left px-6 py-6 rounded-lg flex items-center justify-between",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleOpenCreateScale && $setup.handleOpenCreateScale(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_GerenciarEscalasIcon, {
                  width: "32",
                  height: "32",
                  color: "white"
                })
              ]),
              _hoisted_4,
              _hoisted_5
            ]),
            (_openBlock(), _createElementBlock("svg", _hoisted_6, [
              _createElementVNode("path", {
                d: $setup.mdiChevronRight,
                fill: "white"
              }, null, 8, _hoisted_7)
            ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ListSchedules, {
      onRemoveSchedule: $setup.handleRemove,
      onUpdateSchedule: $setup.handleUpdate,
      onUpdatePosition: $setup.handleUpdatePosition,
      onRemovePosition: $setup.handleRemovePosition,
      onShowPositions: $setup.handleToShowPositions,
      onShowCompanyPolicies: $setup.handleToShowCompanyPolicies,
      onShowHealthUnitPolicies: $setup.handleToShowHealthUnitPolicies,
      onShowSchedulePolicies: $setup.handleToShowSchedulePolicies,
      onShowPositionPolicies: $setup.handleToShowPositionPolicies
    }, null, 8, ["onRemoveSchedule", "onUpdateSchedule", "onUpdatePosition", "onRemovePosition", "onShowPositions", "onShowCompanyPolicies", "onShowHealthUnitPolicies", "onShowSchedulePolicies", "onShowPositionPolicies"]),
    _createVNode(_component_CreateHospitalModal, {
      type: "create",
      modalStateProp: $setup.showCreateHospitalModal,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showCreateHospitalModal = false))
    }, null, 8, ["modalStateProp"]),
    _createVNode(_component_RemoveScheduleModal, {
      "schedule-id": $setup.scheduleIdToDelete,
      "schedule-name": $setup.scheduleNameToDelete
    }, null, 8, ["schedule-id", "schedule-name"]),
    ($setup.modals[$setup.EModals.UPDATE_SCHEDULE] && $setup.scheduleToUpdate)
      ? (_openBlock(), _createBlock(_component_UpdateScheduleModal, {
          key: 0,
          "schedule-id": $setup.scheduleToUpdate.id
        }, null, 8, ["schedule-id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PositionsModal, { "schedule-id": $setup.scheduleIdToShowPositions }, null, 8, ["schedule-id"]),
    _createVNode(_component_PoliciesModal, {
      "companie-id": $setup.companyIdToShowPolicies,
      "healthUnit-id": $setup.healthUnitIdToShowPolicies,
      "schedule-id": $setup.scheduleIdToShowPolicies,
      "position-id": $setup.positionIdToShowPolicies
    }, null, 8, ["companie-id", "healthUnit-id", "schedule-id", "position-id"]),
    _createVNode(_component_RemovePositionModal, {
      "schedule-id": $setup.scheduleIdToDelete,
      "position-id": $setup.positionIdToDelete
    }, null, 8, ["schedule-id", "position-id"]),
    ($setup.modals[$setup.EModals.UPDATE_POSITION])
      ? (_openBlock(), _createBlock(_component_UpdatePositionModal, {
          key: 1,
          "schedule-id": $setup.scheduleIdToShowPositions,
          "position-id": $setup.positionIdToUpdate
        }, null, 8, ["schedule-id", "position-id"]))
      : _createCommentVNode("", true),
    ($setup.scheduleToUpdate)
      ? _withDirectives((_openBlock(), _createBlock(_component_EditScheduleModal, {
          key: 2,
          "schedule-details": $setup.scheduleToUpdate,
          "initial-tab-slug": $setup.initialTabSlug
        }, null, 8, ["schedule-details", "initial-tab-slug"])), [
          [_vShow, $setup.modals[$setup.EModals.EDIT_SCHEDULE]]
        ])
      : _createCommentVNode("", true)
  ], 64))
}